module.exports = __webpack_public_path__ + "files/SPIADI2022 - POSE D'UN CVC EN NEONATALOGIE - V2.2db64a4256b63d69c700f7b2e775d3df.pdf";